export default "__VITE_ASSET__UrmnaFIs__"